import React, { useState, useLayoutEffect, useEffect } from 'react';
import { AddDataBoxButton } from '../AddDataBox';
import { TextField, Box, Tab, Modal } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ApiService from '../../../functions/apiService';
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';

const EditMenu = (({
    open,
    handleClose,
    value,
    input,
    setInput,
    quantity,
    setQuantity,
    handleInsertNode,
    handleChange,
    buttonRef,
    id,
    editType,
    loadData
}) => {
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [loading, setLoading] = useState(true);
    const [title, setTitle] = useState('');
    const [itemQuantity, setItemQuantity] = useState('');
    const [type, setType] = useState('');
    const [locId, setLocId] = useState('');
    const [itemId, setItemId] = useState('');
    const [rootId, setRootId] = useState('');

    useLayoutEffect(() => {
        if (!open || !buttonRef.current) return;

        const rect = buttonRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const modalHeight = 220;

        let topPosition = rect.bottom;

        if (topPosition + modalHeight > windowHeight) {
            topPosition = rect.top - modalHeight;
        }

        if (topPosition < 0) {
            topPosition = 60;
        }

        setModalPosition({ top: topPosition + window.scrollY, left: rect.left + window.scrollX });
    }, [open, buttonRef]);

    const getLocation_Item = () => {
        if (id) {
            ApiService.get('/edit-location-and-item/' + id)
                .then(({ data }) => {
                    setTitle(data?.data?.location_description)
                    setType(data?.data?.type)
                    setLocId(data?.data?.location_parent_id)
                    setRootId(data?.data?.id)
                })
                .catch((e) => {
                    console.log(e);
                })
        }
    }

    const getItem = () => {
        if (id) {
            ApiService.get('/edit-item/' + id)
                .then(({ data }) => {
                    setTitle(data?.data?.item?.item_description)
                    setItemQuantity(data?.data?.item_quantity)
                    setType("item")
                    setLocId(data?.data?.location_id)
                    setItemId(data?.data?.item_id)
                    setRootId(data?.data?.id)
                })
                .catch((e) => {
                    console.log(e);
                })
        }
    }

    const updateInventory = () => {
        const body = {
            "location_id": locId,
            "id": rootId,
            "type": type == "location_item" ? "both" : type,
            "name": title,
            "quantity": itemQuantity,
            "item_id": itemId
        }
        setLoading(true);
        ApiService.post('/update-inventory', body)
            .then((data) => {
                setLoading(false);
                toast.success(data.message)
                navigate("/firehouse/inventory/");
                handleClose()
                loadData()
            })
            .catch((error) => {
                setLoading(false)
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.data.message)
                }
            })
    }

    useEffect(() => {
        if (editType == 'item') {
            getItem()
        }
        else {
            getLocation_Item()
        }
    }, [])

    let navigate = useNavigate();

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                sx={{
                    position: "absolute",
                    top: modalPosition.top,
                    left: modalPosition.left,
                    zIndex: 1300,
                    "& .MuiBackdrop-root": {
                        backgroundColor: "transparent !important",
                    },
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '20px',
                        width: '400px',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)',
                    }}
                >
                    <div id="modal-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '16px' }}>
                        <p style={{ fontSize: '16px', color: '#BF1D2D', fontWeight: '600' }}>{editType == 'item' ? "Edit Item" : "Edit Location"}</p>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <TabContext value={value}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <TextField
                                id="outlined-basic"
                                label={editType == 'item' ? "Item Name" : "Location Name"}
                                variant="outlined"
                                size="small"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        updateInventory();
                                    }
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        height: '40px',
                                        width: editType == 'item' ? '170px' : '350px',
                                    },
                                    marginTop: '-10px',
                                }}
                            />

                            {editType == "item" &&
                                <TextField
                                    id="outlined-basic"
                                    className="quantity"
                                    label="Quantity"
                                    variant="outlined"
                                    value={itemQuantity}
                                    onChange={(e) => setItemQuantity(e.target.value)}
                                    size="small"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            updateInventory();
                                        }
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: '40px',
                                            width: '170px',
                                        },
                                        marginTop: '-10px',
                                    }}
                                />
                            }
                        </div>
                        <div style={{ marginLeft: '22px' }}>
                            <AddDataBoxButton
                                handleClick={() => updateInventory()}
                                buttonText="Update"
                                className="button-class"
                            />
                        </div>
                    </TabContext>
                </Box>
            </Modal>
        </>
    );
});

export default EditMenu;